import _ from 'underscore';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { CollectionUtils } from '~src/Collections/utils/CollectionUtils';
import { IsNlpEnabled } from '~src/lens/utils/LensUtil';
import { isProjectSpace, SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

import { MixedContentItemDefinition } from '../../contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ExplorableItemType } from '../../models/ContentType';

export namespace FilterByTypeDropdownHelpers {
  export const getContentDefinitions = (
    useShowWorkbooksAsViews: boolean,
    showWorkbooksAsViews: boolean,
    flowsEnabled: boolean,
    hiddenContentTypes: ReadonlyArray<ExplorableItemType> = [],
    contentItemDefinitions: MixedContentItemDefinition[],
    spaceInfo: SpaceInfo
  ): MixedContentItemDefinition[] => {
    const items: MixedContentItemDefinition[] = [];

    for (const typeDef of contentItemDefinitions) {
      if (
        (typeDef.itemType === 'database' && !isProjectSpace(spaceInfo)) ||
        (typeDef.itemType === 'table' && !isProjectSpace(spaceInfo)) ||
        (typeDef.itemType === 'flow' && !flowsEnabled) ||
        (typeDef.itemType === 'lens' && !IsNlpEnabled()) ||
        (typeDef.itemType === 'dataRole' && !IsNlpEnabled()) ||
        (typeDef.itemType === 'virtualConnection' && !FeatureFlags.publishedConnectionContentManagementEnabled) ||
        (typeDef.itemType === 'collection') && !CollectionUtils.checkCollectionSiteSetting() ||
        (typeDef.itemType === 'predictiveModel') ||
        (hiddenContentTypes.length && _.contains(hiddenContentTypes,typeDef.itemType))) {
        continue;
      }

      if (useShowWorkbooksAsViews) {
        if (!showWorkbooksAsViews && typeDef.itemType === 'view') {
          // Showing workbooks only.
          continue;
        } else if (showWorkbooksAsViews && typeDef.itemType === 'workbook') {
          // Showing views instead.
          continue;
        }
      }
      items.push(typeDef);
    }

    return items;
  };

  export const showingViewsOrWorkbooks = (currentTypeFilters: ReadonlyArray<ExplorableItemType>): boolean => {
    return _.some(currentTypeFilters, (contentType: ExplorableItemType) => {
      return contentType === 'workbook'
        || contentType === 'view';
    });
  };

  export const isCurrentlyFilteredContentType = (value: string, currentTypeFilters: ReadonlyArray<ExplorableItemType>) => {
    return _.some(currentTypeFilters, (selectedItem) => {
      if (selectedItem === 'dataconnection') {
        return value === 'datasource';
      }
      return selectedItem === value;
    });
  };

}
